export enum QuestionType {
  Likert5 = 0,
  FreeText = 1,
  YesNo = 2
}
